import React from "react";
import { usePagination, DOTS } from "./usePagination";
import "./pagination.css";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const RemotePagination = (props) => {
  const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize, className } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className={`pagination-container ${className ? className : ""}`}>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink previous onClick={onPrevious} key={Math.random()}></PaginationLink>
      </PaginationItem>

      {paginationRange.map((pageNumber) => {
        if (pageNumber === NaN) return null;
        if (pageNumber === DOTS)
          return (
            <PaginationItem>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          );
        // <PaginationItem></PaginationItem>
        return (
          <PaginationItem key={pageNumber} active={pageNumber === currentPage ? true : false}>
            <PaginationLink onClick={() => onPageChange(pageNumber)} key={pageNumber}>
              {pageNumber?.toString()}
            </PaginationLink>
          </PaginationItem>
        );
      })}
      <PaginationItem disabled={currentPage === lastPage}>
        <PaginationLink next onClick={onNext} key={Math.random()}></PaginationLink>
      </PaginationItem>
    </ul>
  );
};

export default RemotePagination;
